import React from 'react';
import { useLocation } from 'react-router-dom';
import { FiHome, FiGrid, FiBriefcase, FiMoreHorizontal } from 'react-icons/fi';
import { useCurrentAdmin } from '../../hooks/useCurrentAdmin';
import { useViewTransitionNavigation } from '../../hooks/useViewTransitionNavigation';
import type { AdminRole } from '../../types/api';

interface BottomNavItem {
  icon: React.ElementType;
  label: string;
  path: string;
  roles: AdminRole[];
}

const BOTTOM_ITEMS: BottomNavItem[] = [
  { icon: FiHome, label: 'Inicio', path: '/home', roles: ['root', 'admin', 'supervisor', 'backseller', 'telemarket', 'viewer'] },
  { icon: FiBriefcase, label: 'Mis Inst.', path: '/my-schools', roles: ['backseller', 'telemarket'] },
  // Telemarket NO ve "Instituciones" (base completa) — solo "Mis Inst.".
  { icon: FiGrid, label: 'Instituciones', path: '/schools', roles: ['root', 'admin', 'supervisor', 'backseller', 'viewer'] },

  { icon: FiMoreHorizontal, label: 'Mas', path: '/more', roles: ['root', 'admin', 'supervisor', 'backseller', 'telemarket', 'viewer'] },
];

interface BottomNavProps {
  onMorePress: () => void;
}

const BottomNav: React.FC<BottomNavProps> = ({ onMorePress }) => {
  const { role } = useCurrentAdmin();
  const location = useLocation();
  const navigate = useViewTransitionNavigation();

  const visibleItems = BOTTOM_ITEMS
    .filter((item) => role && item.roles.includes(role))
    .slice(0, 5);

  const isActive = (path: string) => {
    if (path === '/home') return location.pathname === '/home';
    if (path === '/more') return false;
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-surface border-t border-border md:hidden">
      <div className="flex items-center justify-around h-16 px-2 safe-area-pb">
        {visibleItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          const isMore = item.path === '/more';
          return (
            <button
              key={item.path}
              onClick={() => (isMore ? onMorePress() : navigate(item.path))}
              className={`flex flex-col items-center justify-center gap-0.5 min-w-[56px] min-h-[44px] rounded-lg transition-colors ${
                active ? 'text-primary-600' : 'text-content-tertiary'
              }`}
            >
              <Icon className="w-5 h-5" />
              <span className="text-[10px] font-medium leading-tight">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
